module.exports = __webpack_public_path__ + "img/user-teacher.c2ae1253.png";